(function($) {
  (async function() {

    const quotes = document.querySelector(".shopify-section-quotes");
    quotes.style.visibility = "hidden";

    try {
      if (shopAlias === undefined) {
        throw new Error("shopAlias undefined");
      }
      
      let products = {};
      let reviews = [];
  
      try {
        const url = (function(l) {
          return l.protocol+"//"+l.host;
        })(location);
        const res = await fetch(url+"/products.json", {
          method: "get",
        });
        const json = await res.json();
        for (let i=0; i<json.products.length; i++) {
          const product = json.products[i];
          product.productURL = url+"/products/"+product.handle;
          products[product.id] = product;
        }
      } catch (error) {
        throw new Error(error.message);
      }
  
      if (products.length === 0) {
        throw new Error("products length: "+roducts.length);
      }
  
      try {
        const url = "https://ktnbpeply1.execute-api.ap-northeast-2.amazonaws.com/production/shopify/reviews/recommend";
        const res = await fetch(url, {
          method: "get",
          headers: {
            "x-shop-alias": shopAlias,
            "x-shop-customer-id": ""
          }
        });
        const json = await res.json();
        const tpl = Handlebars.compile(document.getElementById("main-review-item-tpl").innerHTML);
        const starRatingTag = '<span><svg style="fill: #ffc400;" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"></path></svg></span>';
        reviews = json.reviews.filter((review) => {
          const product = products[review.productId];
          if (product === undefined) {
            return;
          }
          const starRatingHTML = [];
          for (let i=0; i<review.rating; i++) {
            starRatingHTML.push(starRatingTag);
          }
          quotes.querySelector(".review-slide-wrapper").insertAdjacentHTML('beforeend', tpl({
            review: review, 
            product: product,
            reviewRating: starRatingHTML.join("")
          }))
          review.product = product;          
          return true;
        })
      } catch (error) {
        throw new Error(error.message);
      }
      
      if (reviews.length < 5) {
        throw new Error("reviews length: "+reviews.length);
      }
      
      var reviewSliderSwiper = new Swiper('.review-slide-container', {
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 30,    
        loop: true,
        navigation: {
          nextEl: '.review-next',
          prevEl: '.review-prev'
        },
        breakpoints: {
          769: {
            slidesPerView: 3,
            centeredSlides: true,
          },
          1101: {
            slidesPerView: 4,
            centeredSlides: true,
          }
        },
        autoplay: {
          delay: 3000
        }
      })

      setTimeout(() => {
        quotes.style.visibility = "visible";
      }, 500);
    } catch (error) {
      quotes.parentNode.removeChild(quotes);
    }
  })();

  var isIOS = function() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  if (isIOS()) {
    document.getElementById("shopify-section-hero-2").children[0].style.backgroundAttachment = "local";
  }
})(jQuery);

